<template>
   <div>
      <p class="text-gray-900">Tarkista vielä hakemuksesi tiedot alta.</p>

      <h2 class="text-xl mt-5 text-pilke-primary">Kaupunki</h2>
      {{storeState.area}}

      <h2 class="text-xl mt-5 text-pilke-primary">Lapsen tiedot</h2>
      <div class="pl-3">
         <div>
            <label>Nimi</label>
            <span> {{storeState.child.firstname}} {{storeState.child.lastname}} </span>
         </div>

         <div>
            <label>Osoite</label>
            <div> {{storeState.child.address.street}} </div>
            <div> {{storeState.child.address.zip}} {{storeState.child.address.city}} </div>
         </div>

         <div>
            <label>Koulu ja luokka</label>
            <div> {{storeState.child.schoolAndClass}} </div>
         </div>

         <div>
            <label>Kaveritoiveet</label>
            <div> {{storeState.child.friends}} </div>
         </div>

         <div>
            <label>Allergia ja lääkitys</label>
            <div> {{storeState.child.allergies}} </div>
         </div>

         <div>
            <label>Erityistä lapsestani</label>
            <div> {{storeState.child.specialNeeds}} </div>
         </div>

         <div>
            <label>Mahdollinen koulutaksilla kulkeminen</label>
            <div> {{storeState.child.schoolRide}} </div>
         </div>

         <div>
            <label>Tietojenvälityslupa</label>
            <div> {{storeState.child.dataPassRequest === true ? 'Kyllä' : 'Ei'}} </div>
         </div>

         <div>
            <label>Valokuvauslupa</label>
            <div> {{storeState.child.photographyRequest === true ? 'Kyllä' : 'Ei'}} </div>
         </div>

         <div>
            <label>Erityiset toiveet</label>
            <div> {{storeState.child.comments}} </div>
         </div>
      </div>

      <h2 class="text-xl mt-5 text-pilke-primary">Huoltajien tiedot</h2>
      <div class="pl-3" v-for="(caretaker, index) in storeState.caretakers" v-bind:key="index">
         <label>Nimi</label>
         {{caretaker.firstname}} {{caretaker.lastname}}

         <label>Osoite</label>
         <div> {{caretaker.address.street}} </div>
         <div> {{caretaker.address.zip}} {{caretaker.address.city}} </div>
      </div>

      <h2 class="text-xl mt-5 text-pilke-primary">Hoidon tarve</h2>
      <div class="pl-3">
         <label>Tarve</label>
         <span> {{getNeedLabel(storeState.need.option)}} </span>

         <label>Toivottu aloituspäivä</label>
         <span> {{renderDate(storeState.need.startdate)}} </span>
      </div>

      <h2 class="text-xl mt-5 text-pilke-primary">Lisätiedot</h2>
      <div class="pl-3">
         {{storeState.comments}}
      </div>

      <div class="mt-5 text-center">
         <button class="btn-terms" v-bind:class="{'approved': storeState.approveTerms}" @click="store.approveTerms()" type="button">Valtuutan antamani tiedot oikeiksi</button>
      </div>

      <div>
         <p class="mt-10 mb-10">Lähettämällä hakemuksen suostun siihen, että koulun rehtori /luokanopettaja /erityisopettaja tai oppilashuollon henkilöstö (kouluterveydenhoitaja, psykologi, kuraattori) ja iltapäivätoiminnan palveluntuottaja sekä ohjaaja saavat luovuttaa toisilleen lapsesta sellaisia tietoja, jotka ovat tarpeellisia iltapäivätoiminnan järjestämisessä</p>
      </div>
   </div>
</template>

<script>
export default {
   name: 'applicationsummary',

   props: ['store'],

   data () {
      return {
         storeState: this.store.state
      }
   },

   methods: {
      getNeedLabel (needCode) {
         if (needCode === 'preschool') return 'Esiopetus'
         if (needCode === 'parttime') return 'Osa-aikainen'
         if (needCode === 'fulltime') return 'Kokoaikainen'
         if (needCode === 'other') return 'Jokin muu'

         return ''
      },

      renderDate (birthdate) {
         return birthdate.day + '.' + birthdate.month + '.' + birthdate.year
      }
   }
}
</script>

<style scoped>
.btn-terms {
   @apply max-w-md;
   @apply bg-gray-300;
   @apply border border-solid border-gray-500;
   @apply rounded;
   @apply py-3 px-3;
   @apply text-left;
}

.btn-terms.approved {
   @apply border-pilke-primary;
   @apply text-white;
   @apply bg-pilke-primary;
   @apply pl-12;
   background-image: url('../assets/checkmark.png');
   background-repeat: no-repeat;
   background-position: left 13px center;
}
</style>
